export const meta: BlockMeta = {
  title: "Category Carousel",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { Themed } from "@components/atoms/Themed"
import { Gradient, GradientType } from "@components/motion/Gradient"
import { Button } from "@components/ui/Button"
import { useCarousel } from "@hooks/useCarousel"
import { useIsMobile } from "@hooks/useIsMobile"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"
import { useEffect, useRef, useState } from "react"

const CatCard = ({ title, url, theme }: { title: string; url: string; theme: string }) => {
  const [hovered, setHovered] = useState(false)
  const isMobile = useIsMobile()

  return (
    <div
      className="carousel-snap w-blockCategoryW h-blockCategoryH"
      onMouseOver={() => setHovered(true)}
      onMouseOut={() => setHovered(false)}
    >
      <Themed type="bg" theme={theme} className="w-full h-full relative group">
        {/* <Gradient
          theme={theme}
          className="absolute left-0 top-0 h-full bg-black"
          aspect="1/1"
          showImage={false}
          cutEdges={false}
          align="left"
          scale={1}
          bg={{ r: 0, g: 0, b: 0 }}
          desaturated={!hovered && !isMobile}
        /> */}
        <div className="bg-grey6 transition-opacity absolute w-full h-full opacity-0 md:opacity-100 md:group-hover:opacity-0 duration-500" />
        <div className="w-full h-full relative">
          <Link
            href={url}
            className="w-full h-full mr-4 flex p-4 items-end justify-start type-title-l transition-colors duration-500 text-black md:text-white md:group-hover:text-black"
          >
            {title}
          </Link>
        </div>
      </Themed>
    </div>
  )
}

export default defineBlock("content/category-carousel", (props) => {
  const gradientRef = useRef<GradientType>(null)
  const { carouselRef, current, setCurrent, setEnabled } = useCarousel({
    snapElement: ".carousel-snap",
    spacerElement: ".carousel-spacer",
    setOuterHeight: true,
  })
  const refreshTimer = useRef<number | null>(null)
  const items = props.items || []

  const next = () => {
    setCurrent((current + 1) % items.length)
  }

  const previous = () => {
    setCurrent((current - 1 + items.length) % items.length)
  }

  useEffect(() => {
    if (refreshTimer.current) window.clearTimeout(refreshTimer.current)
    setEnabled(false)
    refreshTimer.current = window.setTimeout(() => {
      setEnabled(true)
    }, 250)
  }, [props.items])

  return (
    <div className="w-full my-10 px-4 flex flex-col gap-4">
      <p className="type-title-s uppercase">
        <EditableText
          store="title"
          as="span"
          placeholder="Browse By Category"
          defaultValue="Browse by Category"
          plainText
        />
      </p>
      <div ref={carouselRef} className="carousel relative overflow-hidden">
        <div className="carousel-spacer w-4" />
        {props.items?.map((category, i) => (
          <CatCard
            key={i}
            title={category?.title || ""}
            url={category?.link?.url || ""}
            theme={category?.theme || "yellow"}
          />
        ))}

        {items.length > 1 && (
          <div className="absolute right-6 bottom-6 flex gap-2">
            <Button icon="chevronLeft" variant="secondary" onClick={() => previous()} />
            <Button icon="chevronRight" variant="secondary" onClick={() => next()} />
          </div>
        )}
      </div>
    </div>
  )
})
